import { styled } from '@mui/material';

import { IconButton } from '@knowz/knowz-ui';

const StyledIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: 10,
  right: 10,
}));

export default StyledIconButton;
